export const UPDATE_USER = 'UPDATE_USER';
export const SUBMIT_USER = 'SUBMIT_USER';
export const REQUEST_USER = 'REQUEST_USER';
export const RECEIVE_USER = 'RECEIVE_USER';
export const TOGGLE_COLLABORATION = 'TOGGLE_COLLABORATION';
export const LOGOUT_USER = 'LOGOUT_USER';
